// export const API_URL = "http://localhost:5000";
export const API_URL = "https://carmel-backend.onrender.com";
export const STORAGE_KEY = "USER_STORAGE";
